import { Box, Typography, Slider as MaterialSlider } from "@mui/material";

export default function StaticSlider({
  question,
  onMouseDownHandler = () => {},
}) {
  const isSmiley = question.type === "smiley";
  return (
    <Box width="80%" paddingTop={1}>
      <Box display="flex" justifyContent="center">
        <Box width="65%" display="flex" justifyContent="space-between">
          <Typography
            variant="body2"
            paddingLeft={"3px"}
            color="text.secondary"
            onClick={(event) => {
              event.stopPropagation();
              onMouseDownHandler(`leftValue`);
            }}
          >
            {question.marks[0].value}
          </Typography>
          <Typography
            variant="body2"
            paddingRight={"11px"}
            color="text.secondary"
            onClick={(event) => {
              event.stopPropagation();
              onMouseDownHandler(`rightValue`);
            }}
          >
            {question.marks[1].value}
          </Typography>
        </Box>
      </Box>
      <Box display="flex" alignItems="center">
        <Box
          marginRight={1}
          sx={{
            visibility: isSmiley ? "hidden" : "visible",
            width: 86,
          }}
          onClick={(event) => {
            event.stopPropagation();
            onMouseDownHandler(`leftLabel`);
          }}
        >
          <Typography variant="body2" noWrap>
            {question.marks[0].label}
          </Typography>
        </Box>
        <Box paddingRight={2} />
        <Box width={"100%"}>
          <MaterialSlider
            disabled
            defaultValue={50}
            aria-labelledby="discrete-slider-custom"
            step={1}
            sx={{ color: "rgb(168 168 168)" }}
            size="small"
          />
        </Box>
        <Box paddingRight={6} />
        <Box
          sx={{
            visibility: isSmiley ? "hidden" : "visible",
          }}
          onClick={(event) => {
            event.stopPropagation();
            onMouseDownHandler(`rightLabel`);
          }}
        >
          <Typography variant="body2" noWrap>
            {question.marks[1].label}
          </Typography>
        </Box>
        <Box paddingRight={1} />
      </Box>
    </Box>
  );
}
